import { render, staticRenderFns } from "./_Decision.vue?vue&type=template&id=f4f24974"
import script from "./_Decision.vue?vue&type=script&lang=js"
export * from "./_Decision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports